import { AxiosInstance } from 'axios'
import { AccessDenied } from 'shared/errors/access-denied'
import { ConflictError } from 'shared/errors/conflict-error'
import { LockedError } from 'shared/errors/locked'
import { NotFound } from 'shared/errors/not-found'
import { UnauthorizedResponse } from 'shared/errors/unauthorized-response'
import { UnprocessableContentError } from 'shared/errors/unprocessable-content-error'
import {
  DefaultFieldsType,
  ErrorResponseInterface,
} from 'shared/types/error-response-content-interface'

export enum RequestMethodsEnum {
  get = 'get',
  delete = 'delete',
  head = 'head',
  options = 'options',
  post = 'post',
  put = 'put',
  patch = 'patch',
  postForm = 'postForm',
}

export type UseApiWrapperWithErrorValidationProps<
  R,
  M extends RequestMethodsEnum,
  BadRequestError = ErrorResponseInterface,
> = {
  method: M
  showFieldsErrorToast?: boolean
  badRequestHandler?: null | ((error: BadRequestError) => void)
  unprocessableContentHandler?: (error: UnprocessableContentError) => void
  conflictResponseHandler?: (error: ConflictError<DefaultFieldsType>) => void
  unauthorizedResponseHandler?: (error: UnauthorizedResponse) => void
  afterFetch?: (data: R) => Promise<R> | R
  stopErrorPropagation?: boolean
  notFoundResponseHandler?: (error: NotFound) => void
  accessDeniedResponseHandler?: (error: AccessDenied) => void
  lockedResponseHandler?: (error: LockedError) => void
}

export type FetcherType<M extends RequestMethodsEnum, R = void> = (
  ...args: Parameters<AxiosInstance[M]>
) => Promise<R>
